<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="B2B Provider Configuration"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="false"
      />
    </b-col>
    <b-col>
      <b-card>
        <b-row>
          <template v-if="isLoadingGateways">
            <b-col cols="12" class="b2b-empty-state">
              <div class="text-muted">Loading B2B providers...</div>
            </b-col>
          </template>
        </b-row>
        <b-row v-if="b2bGatewayList.length">
          <b-col md="4" v-for="(gateway, index) in b2bGatewayList" :key="index"
            ><configCard
              :imgSrc="getGatewayLogo(gateway)"
              :name="gateway.name"
              :detailsText="gateway.description"
              :isConfigured="
                b2bConfiguredGatewayList?.[gateway.key] ||
                b2bConfiguredGatewayList?.recharge?.[gateway.key]
                  ? true
                  : false
              "
              :showSwitch="false"
              :showSetting="false"
              @onClickConfigure="onClickConfigure(gateway)"
            ></configCard
          ></b-col>
        </b-row>
        <b-row v-else-if="!isLoadingGateways">
          <b-col cols="12" class="b2b-empty-state">
            <div class="b2b-empty-title">No B2B providers found</div>
            <p class="b2b-empty-text mb-0">
              B2B provider data is not available right now.
            </p>
          </b-col>
        </b-row>
        <template>
          <b-modal
            hide-header
            id="thirdparty-gateway-config"
            size="md"
            ref="gateway-config"
            centered
            hide-footer
          >
            <h4 class="text-capitalize pb-3">{{ gatewayInfo.name }}</h4>
            <!-- <b-row>
              <b-col md="6">
                <eb-select
                  type="select"
                  :options="marketList"
                  label="text"
                  id="SelectMarket"
                  placeholder="Select Market"
                  class="mt-0 currencyNameDropdown mb-0"
                  v-model="selectMarket"
                  :selected="selectMarket"
                  @input="onSelectCode(selectMarket)"
                ></eb-select>
              </b-col>
            </b-row> -->
            <b-row>
              <b-col md="6">
                <b-form-input
                  maxlength="500"
                  type="text"
                  placeholder="Username"
                  v-model="username"
                ></b-form-input>
              </b-col>
              <b-col md="6">
                <b-form-input
                  maxlength="500"
                  type="password"
                  placeholder="Password"
                  v-model="password"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col v-if="gatewayInfo.name == 'healthians'">
                <b-form-input
                  maxlength="500"
                  placeholder="Checksum Key"
                  v-model="merchantId"
                ></b-form-input>
              </b-col>
              <b-col v-else>
                <b-form-input
                  maxlength="500"
                  placeholder="Authentication Key"
                  v-model="merchantId"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="justify-content-md-center mt-3">
              <b-col md="4" class="cancel-btn-col">
                <b-button variant="danger" block @click="hideModal"
                  >Cancel</b-button
                >
              </b-col>
              <b-col md="4">
                <b-button
                  variant="primary"
                  block
                  @click="onClickSaveConfig(gatewayInfo)"
                  >Save</b-button
                >
              </b-col>
            </b-row>
          </b-modal>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
// import ebSelect from "@/components/FormElements/Select.vue";
import profile from "@/components/profile/profileCategory";
import configCard from "@/components/tenantConfig/configCard.vue";
import { mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import { BUCKET_BASEURL } from "@/services/index";
export default {
  components: {
    profile,
    configCard,
    ComponentHeader,
    // ebSelect,
  },
  data() {
    return {
      gatewayInfo: {},
      merchantId: "",
      username: "",
      password: "",
      configuredGateway: [],
      unconfiguredGateway: [],
      isLoadingGateways: false,
      //   selectMarket: {
      //     value: "market1",
      //     text: "Market",
      //   },
      //   marketList: [
      //     {
      //       value: "market1",
      //       text: "Market",
      //     },
      //     {
      //       value: "market2",
      //       text: "Grocery",
      //     },
      //   ],
    };
  },
  computed: {
    ...mapState({
      b2bGatewayList: (state) => state.tenant.b2bGatewayList,
      b2bConfiguredGatewayList: (state) => state.tenant.b2bConfiguredGateway,
    }),
  },
  methods: {
    getGatewayLogo(gateway) {
      const logo = gateway && gateway.logo;
      if (!logo) {
        return require("@/assets/images/mob-default-img.svg");
      }
      if (/^https?:\/\//i.test(logo)) {
        return logo;
      }
      const normalizedLogo = logo.startsWith("/") ? logo.slice(1) : logo;
      return `${BUCKET_BASEURL}/${normalizedLogo}`;
    },
    onClickConfigure(gatewayData) {
      this.gatewayInfo = gatewayData;
      this.$refs["gateway-config"].show();
    },
    hideModal() {
      this.$refs["gateway-config"].hide();
    },
    async onClickSaveConfig(gatewayInfo) {
      let payload = {};
      if (gatewayInfo?.name == "mobikwik") {
        payload = {
          recharge: {
            mobikwik: {
              uid: this.username,
              pwd: this.password,
              key: this.merchantId,
            },
          },
        };
      }
      if (gatewayInfo.name == "healthians") {
        payload = {
          Healthians: {
            username: this.username,
            password: this.password,
            checksumkey: this.merchantId,
          },
        };
      }
      if (this.username && this.password && this.merchantId) {
        await this.$store
          .dispatch("tenant/getB2bGatewayConfigure", payload)
          .then((result) => {
            this.$swal({
              title: "Success!",
              text: "B2B Provider Configured Successfully.",
              type: "success",
            }).then(async (result) => {
              let payload = {};
              await this.$store.dispatch(
                "tenant/getB2bConfiguredGateway",
                payload
              );
              this.hideModal();
            });
            (this.merchantId = ""), (this.username = ""), (this.password = "");
          })
          .catch((error) => {
            this.$toasted.error(error.message);
          });
      } else {
        this.$swal({
          title: "Error!",
          text: "All Fields Required!",
          type: "error",
        });
      }
    },
  },
  async mounted() {
    this.isLoadingGateways = true;
    try {
      await this.$store.dispatch("tenant/getB2bGatewayList");
      let payload = {};
      await this.$store.dispatch("tenant/getB2bConfiguredGateway", payload);
    } finally {
      this.isLoadingGateways = false;
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style scoped>
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  font-size: 14px;
}
.card-body {
  padding: 15px;
}
.card-footer {
  border-top: 2px dashed #c8d1d7;
}
@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
@media (max-width: 991px) {
  .cancel-btn-col {
    margin-bottom: 10px;
  }
}
.description {
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
  min-height: 6rem;
  -webkit-box-orient: vertical;
}

.b2b-empty-state {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 2rem 1rem;
}

.b2b-empty-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--secondary);
  margin-bottom: 0.5rem;
}

.b2b-empty-text {
  color: #6c757d;
}
</style>
